import { Routes } from '@angular/router';
import { provideAdminStore } from '@app/store/admin';
import { ModalComponent } from '@shared/components';
import { AddComponent } from './add/add.component';
import { ViewComponent } from './view/view.component';
import { EditComponent } from './edit/edit.component';

export const adminsModalRoutes: Routes = [
    {
        path: 'admins/add',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideAdminStore()],
        children: [{ path: '', component: AddComponent }],
    },
    {
        path: 'admins/view/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideAdminStore()],
        children: [{ path: '', component: ViewComponent }],
    },
    {
        path: 'admins/edit/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideAdminStore()],
        children: [{ path: '', component: EditComponent }],
    },
];
